import Button from '@space-core/components/button'
import Image from '@space-core/components/image'
import { ComponentNames } from '@space-core/datahub'
import { DataHubEntities, DataHubService } from '@space-core/datahub/hotmartClub'
import { useThemeContext } from '@space-core/hooks'
import { useDeviceInfo } from '@space-core/hooks/useDeviceInfo'
import useTranslation from '@space-core/hooks/useTranslation'
import { ThemeMode } from '@space-core/styles/themes/enum'
import { toggleCommunityConfigurationSidebarEventDispatch } from '@space-events/toggleCommunityConfigurationSidebar'
import OpenAccessCommunity from '@space-shell/assets/images/openAccessCommunity.svg'
import OpenAccessCommunityDarkMode from '@space-shell/assets/images/openAccessCommunityDarkMode.svg'
import { useUserInfoStore } from '@space-shell/core/store'
import {
  CommunityEventType,
  useCommunityModal
} from '@space-shell/modules/communities/communityModal'
import ClickToCreateCommunitySchema from '@space-shell/modules/home/datahub/schemas/click/community/clickToCreateCommunitySchema'
import styled from 'styled-components'

const Description = styled.p`
  font-size: 0.875rem;
`

const OpenCommunityState = () => {
  const { dispatchModalEvent } = useCommunityModal()
  const { t } = useTranslation()
  const { theme } = useThemeContext()
  const user = useUserInfoStore()
  const deviceInfo = useDeviceInfo()

  const handleClick = () => {
    DataHubService.sendEvent({
      entity: DataHubEntities.Community,
      schema: new ClickToCreateCommunitySchema({
        deviceInfo,
        userRole: user.role,
        componentName: ComponentNames.CONFIGURATION_MODAL
      })
    })

    toggleCommunityConfigurationSidebarEventDispatch({ action: 'close' })
    dispatchModalEvent(CommunityEventType.OPEN)
  }

  return (
    <div className='_d-flex _my-12 _align-items-center'>
      <Image
        loading='lazy'
        objectFit='contain'
        className='_w-auto _h-auto _mr-5'
        src={theme === ThemeMode.DARK ? OpenAccessCommunityDarkMode : OpenAccessCommunity}
        alt={t('configuration_sidebar.access_and_privacy.open_community_state.title')}
      />
      <div>
        <p className='_text-2 _font-weight _text-gray-900 _mb-1'>
          {t('configuration_sidebar.access_and_privacy.open_community_state.title')}
        </p>
        <Description className='_text-gray-900 _font-weight _mb-4'>
          {t('configuration_sidebar.access_and_privacy.open_community_state.description_v2')}
        </Description>
        <Button data-test='next-step-two' variation='primary' onClick={handleClick} size='sm'>
          {t('configuration_sidebar.access_and_privacy.open_community_state.button')}
        </Button>
      </div>
    </div>
  )
}

export default OpenCommunityState
